import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import { open, openCloseCheck } from './actions'
import LoanCloseCheck from './LoanCloseCheck'
import { LoanCoverTrigger } from './LoanCover'

export { open, openCloseCheck, LoanCoverTrigger, LoanCloseCheck }

export default Loadable(() => import('./LoanCover'))
